import type React from 'react';

import { useGetFace, useGetCard } from '@vlabs/api/artemy/client';
import type { CardId, FaceId } from '@vlabs/api/artemy/model';
import Loader from '@vlabs/shared/legacy-components/loader/Loader';
import type { FaceSampleProps } from '@vlabs/uikit';
import { FaceSample } from '@vlabs/uikit';

interface CardSampleProps extends
  Omit<FaceSampleProps, 'src'> {
  cardId: CardId;
}

function CardSamplePoint3({
  cardId,
  ...props
}: CardSampleProps): React.JSX.Element {
  const getCard = useGetCard(cardId, { targets: ['main_face_id'] });
  const faceId = getCard.data?.main_face_id;
  const getCardFace = useGetFace(faceId as FaceId, { targets: ['avatar'] }, {
    query: { enabled: !!faceId },
  });

  if (getCard.isLoading) return <Loader />;

  return (
    <FaceSample
      src={getCardFace.data?.avatar ? `/api/${getCardFace.data.avatar}` : undefined}
      {...props}
    />
  );
}

export { CardSamplePoint3 };
